import React from 'react';
import './sapb1characteristics.css'; // Make sure to add some custom CSS for layout and styling

/*animated icon */

import Access from "../../assests/financing.gif"
import Platform from "../../assests/sales-enablement.gif"
import Update from "../../assests/accounting.gif"
import Collobaration from "../../assests/business-plan.gif"

const featuresData = [
  {
    title: 'Financial Management',
    description:
      'Automate key accounting processes such as journal entries, accounts receivable, and accounts payable. Gain better control over budgets, cash flow, and fixed assets while ensuring accurate financial reporting and compliance.',
    icon:Access,
  },
  {
    title: 'Sales and Customer Management',
    description:
      'Oversee the entire sales process from lead generation to deal closing and post-sales support. Track sales opportunities, manage customer relationships efficiently, and streamline service agreements and warranty contracts.',
    icon: Platform,
  },
  {
    title: 'Purchasing and Inventory Control ',
    description:
      'Optimize procurement and inventory management by automating the order-to-pay cycle, including purchase orders, receipts, and invoices. Maintain accurate stock levels with real-time synchronization, improve supply chain relationships, and reduce operational costs by effectively managing accounts payable and supplier interactions.',
    icon: Update,
  },
  {
    title: 'Business Intelligence & Analytics',
    description:
      'Access real-time company-wide data to generate insightful reports and interactive dashboards. Utilize advanced analytics, predefined KPIs, and powerful data visualizations to improve cash flow visibility, track sales performance, and enhance decision-making.',
    icon: Collobaration,
  },
  
];

const Webcharacteristics = () => {
  return (
    <>
    <div className='text-center charhead mt-2'>Key Characteristics of SAP Business One (SAP B1)</div>
    <div className=" container features-container">
      {featuresData.map((feature, index) => (
        
        <div key={index} className="feature-card ">
            <div className='row'>
            <div className='col-lg-2'>
          <img src={feature.icon} className="feature-icon" alt='icon'/>
          </div>
          <div className='col-lg-10'>
          <h3 className="feature-title">{feature.title}</h3>
          <p className="feature-description">{feature.description}</p>
          </div>
        </div>
        </div>

      ))}
    </div>
    </>
  );
};

export default Webcharacteristics;
